import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-call-icon',
	templateUrl: './call-icon.component.html',
	styleUrl: './call-icon.component.css'
})
export class CallIconComponent {
	@Input() size = "30";
}
